var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-5 col-11 col-xl-5"},[_c('cmpChart',{attrs:{"chart-type":'ImageUrl',"image-src":_vm.dynamicImageUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }